import { InjectionToken } from '@angular/core';

export const GOOGLE_MAP_POPUP_DATA = new InjectionToken<any>('GOOGLE_MAP_POPUP_DATA');
